import { createFileRoute } from '@tanstack/react-router';
import { Header } from '@/components/Header';
import { GuestLog } from '@/pages/GuestLog';
import { useUserProfile } from '@/lib/hooks/useUserProfile';

export const Route = createFileRoute('/_authenticated/_admin/admin/guest-log')({
  component: GuestLogPage,
});

function GuestLogPage() {
  const { isAdmin, isLoading: isLoadingProfile } = useUserProfile();

  if (isLoadingProfile) {
    return (
      <>
        <Header enableBack additionalClasses="bg-slate-700" />
        <div className="flex justify-center items-center py-12">
          <p className="text-body text-foreground/60">Loading...</p>
        </div>
      </>
    );
  }

  if (!isAdmin()) {
    return (
      <>
        <Header enableBack additionalClasses="bg-slate-700" />
        <div className="flex justify-center items-center py-12 px-4 text-center">
          <p className="text-body text-foreground/80">
            You do not have permission to view the guest log.
          </p>
        </div>
      </>
    );
  }

  return <GuestLog />;
}
